import { Texas } from "../../../net/proto/proto_texasholdem_game";
import { TableHelp } from "../help/table_help";
import { BetMoveEffect } from "./bet_move_effect";

//边池
const {ccclass, property} = cc._decorator;

interface ISidePotData{
    node:cc.Node;
    numbNode:cc.Node;
    sideRoot:cc.Node;
    betEffect:BetMoveEffect;
    totalBet:number;
    target:cc.Node;
}

interface IPoolCfg{
    distance:number;
    scale:number;
}

@ccclass
export default class SidePotEffect extends cc.Component {

    @property(cc.Node)
    prefab:cc.Node = null;

    private sidePool:ISidePotData[] = [];

    private width:number = 180;//基础宽度

    //更新边池,直接全部更新
    updateSidePot(data:Texas.ISidePot[]){
        //重置所有边池
        this.reset();
        let config = this.getConfig(data.length);

        for (let i = 0; i < data.length; i++) {
            if (data[i].totalBet == 0) {
                continue;
            }
            let side = this.sidePool[i];
            if (!side) {
                let node = TableHelp.AddChild(this.prefab,this.node);
                node.position = cc.v2((this.width + config.distance) * i ,0);
                node.scale = config.scale;
                let sideRoot = node.getChildByName('Sideroot');
                let numbNode = sideRoot.getChildByName('numb');
                let target = node.getChildByName('target');
                let betEffect = node.getComponent(BetMoveEffect);
                side = {
                    node:node,
                    sideRoot:sideRoot,
                    numbNode:numbNode,
                    betEffect:betEffect,
                    totalBet:data[i].totalBet,
                    target:target
                }
                this.sidePool.push(side);
            }
            side.sideRoot.active = true;
            let totalBet = data[i].totalBet;
            totalBet = TableHelp.getRightMount(totalBet);
            let numb = TableHelp.addThousands(totalBet);
            TableHelp.setNodeString(side.numbNode,numb);
            side.betEffect.showBet(totalBet);
        }
        //更新位置
        this.node.position = cc.v2(-(data.length * (this.width) + (data.length-1) * config.distance ) * 0.5,this.node.position.y);
    }

    //根据数量进行缩放
    getConfig(count:number):IPoolCfg{
        return {scale:1,distance:10};
        if (count == 1) {
            return {scale:1,distance:0};
        }else if (count == 2) {
            return {scale:1,distance:120};
        }else if (count == 3) {
            return {scale:0.94,distance:90};
        }else if (count == 4) {
            return {scale:0.84,distance:50};
        }else if (count == 5) {
            return {scale:0.72,distance:-20};
        }else if (count == 6) {
            return {scale:0.67,distance:-50};
        }else if (count == 7) {
            return {scale:0.57,distance:-70};
        }else{
            return {scale:0.57,distance:-70};
        }
        
    }

    getPoolData(index:number){
        return this.sidePool[index];
    }

    getPools():ISidePotData[]{
        let sidePool:ISidePotData[] = [];
        for (let pool of this.sidePool) {
            if (pool.sideRoot.active) {
                sidePool.push(pool);
            }
        }
        return sidePool;
    }

    recycleOneSidePot(index:number){
        let pool = this.sidePool[index];
        if (pool) {
            pool.sideRoot.active = false;
            pool.betEffect.recycleAllBet();
        }
    }

    reset(){
        for (let side of this.sidePool) {
            side.sideRoot.active = false;
            side.betEffect.recycleAllBet();
        }
    }

    clear(){
        for (let side of this.sidePool) {
            side.sideRoot.active = false;
            side.betEffect.recycleAllBet();
            side.betEffect.clear();
        }
    }
}
